import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getTeams = () => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `team`);
};
export const getById = (Id: number) => {
  return axios.get(GetBackendUrlForGlobalFunctions() + `team/` + Id);
};

export const createTeam = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.post(GetBackendUrlForGlobalFunctions() + `team/add`, obj, {
    headers,
  });
};

export const teamUpdate = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `team/update`, obj, {
    headers,
  });
};
export const teamDelete = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(GetBackendUrlForGlobalFunctions() + `team/delete`, obj);
};
export const getTeamAssigments = (Id: number) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() + `assignment/team-assignment?where=` + Id
  );
};
